import CarNewForm from "../../Components/Cars/CarNewForm";
import "../../Components/Style/Cars/CarNew.css";

function CarNew() {
  return (
    <div className="car-new-main">
      <CarNewForm />
    </div>
  );
}

export default CarNew;
